import React from 'react';
import { StyleSheet } from 'react-native';
import { Dialog, Portal, Colors } from 'react-native-paper';
import { pixelDimensions } from '../../config/utils';
import { AppButton, AppText } from '../form';

const SimpleModal = ({
  visible, onDismiss, title, question, onSIM, onNAO,
}) => (
  <Portal>
    <Dialog style={styles.dialogBase} visible={visible} onDismiss={onDismiss}>
      <Dialog.Title><AppText size="bold" style={[styles.textBlack, styles.textAnswer]}>{title}</AppText></Dialog.Title>
      <Dialog.Content>
        <AppText style={[styles.textBlack, styles.textQuestion]}>{question}</AppText>
      </Dialog.Content>
      <Dialog.Actions style={styles.buttonContainer}>
        <AppButton size="bold" rippleColor={Colors.cyan800} style={styles.buttonAnswer} onPress={onNAO} labelStyle={[styles.textAnswer, styles.textWhite]} label="Não" />
        <AppButton size="bold" rippleColor={Colors.cyan800} style={styles.buttonAnswer} onPress={onSIM} labelStyle={[styles.textAnswer, styles.textWhite]} label="Sim" />
      </Dialog.Actions>
    </Dialog>
  </Portal>
);

const styles = StyleSheet.create({
  buttonAnswer: {
    backgroundColor: Colors.cyan800,
    paddingVertical: pixelDimensions(2),
    paddingHorizontal: pixelDimensions(4),
  },
  buttonContainer: {
    justifyContent: 'space-around',
  },
  dialogBase: {
    backgroundColor: Colors.white,
  },
  textAnswer: {
    fontSize: pixelDimensions(5),
  },
  textWhite: {
    color: Colors.white,
  },
  textBlack: {
    textAlign: 'justify',
    color: Colors.black,
  },
  textQuestion: {
    fontSize: pixelDimensions(4),
  },
});

export default SimpleModal;
